import { IGoalFormValues } from '@Router/GoalAndOperationalPlans/Containers/GoalAndOperationalPlansFormProvider/types';

export const mapGoals = (goals: IGoalFormValues[]) => {
  return goals.map((goal, index) => ({
    id: index,
    goals: {
      detailTh: goal.detailTh,
      detailEn: goal.detailEn,
    },
    durationOfOperation: {
      durationType: goal.durationType,
      startDate: goal.startDate,
      endDate: goal.endDate,
    },
    criteria: goal.indicators?.map((indicator) => ({
      criteriaTh: indicator.criteriaTh,
      criteriaEn: indicator.criteriaEn,
    })),
  }));
};
